import _each from "lodash/each";
import store from "~/js/store/store";
import _throttle from "lodash/throttle";
import Common from "~/js/common/common";
import { gsap, Cubic, Quint } from "gsap";
import _escape from "lodash/escape";
import sanitizeHtml from "sanitize-html";
import _pullAt from "lodash/pullAt";
export default class BrandSideNavi {
  constructor() {
    this.view = document.querySelector(".l-sidenavi");
    this.naviLength = 0;
    this.activeIndicator = null;
    this.setup();
    this.setupBrandNavi();
    this.setupContrller();
  }

  // セットアップ =========
  /**
   *
   */
  setup() {
    // Store pending focus target for when scroll completes
    this.pendingFocusTarget = null;
    this.unsubscribe = store.subscribe((mutation, state) => {
      if (mutation.type === "multiImage") {
        if (state.app.pinSection.multiImageLength) {
          const section = store.state.app.pinSection.nextSection;
          const sections = section.querySelectorAll(".js-multiimage");
          const nextSection = sections[store.state.app.pinSection.multiImageCount];
          this.updateInfomation(nextSection, store.state.app.pinSection.multiImageCount, store.state.app.pinSection.multiImageLength);
          this.updateInfoControl(sections);
        }
      } else if (mutation.type === "multiImageTime") {
        this.updateMultiImageIndicator();
      } else if (mutation.type === "beforeMultiImageChange") {
        this.updateColor(true);
      } else if (mutation.type === "afterScroll") {
        // Focus the target section after scroll completes
        if (this.pendingFocusTarget) {
          const targetSection = document.getElementById(this.pendingFocusTarget);
          if (targetSection) {
            targetSection.focus();
          }
          this.pendingFocusTarget = null;
        }
      }
    });
    const sections = this.getSections();
    this.naviLength = sections.length;
    this.createSideNavi(sections);
  }

  getSections() {
    let sections = [...document.querySelectorAll(".js-section")];
    let result = sections;
    _each(sections, (section, index) => {
      let onlySp = !!section.getAttribute("data-onlysp");
      if (onlySp && !Common.isSPSize()) {
        result = _pullAt(sections, index);
      }
    });
    return sections;
  }

  createSideNavi(sections) {
    let fragment = document.createDocumentFragment();
    let wrap = this.view.querySelector(".js-brandnaviwrap");
    _each(sections, (section, index) => {
      section.id = "section" + index;
      // Ensure section can receive keyboard focus
      if (!section.hasAttribute('tabindex')) {
        section.setAttribute('tabindex', '-1');
      }
      let category = section.getAttribute("data-category");
      // console.log(category);
      // footerにはカテゴリがないためドットが作成されない
      if (!category) {
        return;
      }
      let li = document.createElement("li");
      let link = document.createElement("a");
      let text = sanitizeHtml(category, {
        allowedTags: "*",
        allowedAttributes: {
          "*": ["class"]
        }
      });
      li.className = "sidenavi js-brandnavi";
      li.setAttribute("data-active", index);
      // Set proper href to target the section ID
      link.setAttribute("href", "#section" + index);
      link.setAttribute("tabindex", "0");
      link.setAttribute("aria-label", "" + text);
      link.className = "js-notabindex";
      link.innerHTML = text;
      li.appendChild(link);
      fragment.appendChild(li);
    });
    wrap.appendChild(fragment);
  }

  /**
   * ブランド ●ナビ クリック時挙動
   */
  setupBrandNavi() {
    const naviList = document.querySelectorAll(".js-brandnavi");
    let tweens = [];
    _each(naviList, (elm, index) => {
      elm.addEventListener("click", (event) => {
        let target = event.currentTarget;
        let _active = target.getAttribute("data-active");
        if (_active) {
          event.preventDefault();
          const sectionIndex = parseInt(_active, 10);
          // Store the target section ID to focus after scroll completes
          this.pendingFocusTarget = "section" + sectionIndex;
          store.dispatch("changePinScroll", {
            index: sectionIndex
          });
          // Focus will be set in the afterScroll subscription handler
        }
      });
    });
    let naviwrap = document.querySelector(".js-brandnaviwrap");
    naviwrap.addEventListener("mouseenter", (event) => {
      _each(tweens, (tw) => {
        tw.kill();
      });
      tweens = [];
      _each(naviList, (el, i) => {
        el.classList.remove("_hover");
        tweens.push(
          gsap.delayedCall(i * 0.02, () => {
            el.classList.add("_hover");
          })
        );
      });
    });
    naviwrap.addEventListener("mouseleave", (event) => {
      _each(tweens, (tw) => {
        tw.kill();
      });
      tweens = [];
      _each(naviList, (el, i) => {
        el.classList.remove("_hover");
      });
    });
  }

  /**
   * 複数(2つ)コレクション時のインターフェース実装（コレクション等）
   */
  setupContrller() {
    const _prev = this.view.querySelector(".js-infocontrol__prev");
    const _next = this.view.querySelector(".js-infocontrol__next");
    const _pause = this.view.querySelector(".js-pause");

    _prev.addEventListener("click", (e) => {
      e.preventDefault();
      store.dispatch("multiImage", {
        length: store.state.app.pinSection.multiImageLength,
        count: 0
      });
    });
    _next.addEventListener("click", (e) => {
      e.preventDefault();
      store.dispatch("multiImage", {
        length: store.state.app.pinSection.multiImageLength,
        count: 1
      });
    });

    if (_pause) {
      _pause.addEventListener("click", (e) => {
        e.preventDefault();
        const pressed = e.target.getAttribute('aria-pressed')
        
        if (pressed === 'false') {
          const pauseMultiImage = new Event('pauseMultiImage')
          document.dispatchEvent(pauseMultiImage);
        } else {
          const playMultiImage = new Event('playMultiImage')
          document.dispatchEvent(playMultiImage);
        }
        
        _pause.setAttribute('aria-pressed', pressed !== 'true')
        _pause.innerHTML = pressed === 'false' ? 'Play Slide' : 'Pause Slide'
      });
    }
    
  }

  // サイドナビ更新 =============
  updateNavi() {
    this.updateActiveNavi();
    this.updateInfomation();
  }

  /**
   * ナビのアクティブ調整
   */
  updateActiveNavi() {
    let currentIndex = store.state.app.pinSection.nextIndex;
    const naviList = document.querySelectorAll(".js-brandnavi");
    const sections = this.getSections();
    _each(naviList, (elm, index) => {
      const link = elm.querySelector('a')
      link && link.setAttribute("aria-current", "false")
      elm.classList.remove("active");
      if (index === currentIndex) {
        elm.classList.add("active");
        link && link.setAttribute("aria-current", "true")
        let section = sections[index];
      }
    });
  }

  /**
   * ナビ背景更新
   * ブランドトップでフッター・その他リンク部分でサイドナビを表示するかをコントロール
   */
  updateBackgroundVisible() {
    //if (store.getters["isLastPin"]) {
    if (store.getters["isLast2Pin"]) {
      this.view.classList.add("hidden");
      /*store.dispatch("scrollY", {
        y: 2000,
        isPin: true
      });*/
    } else {
      this.view.classList.remove("hidden");
      /*store.dispatch("scrollY", {
        y: 0,
        isPin: false
      });*/
    }
  }
  changeBackground(isWhite) {
    if (isWhite) {
      this.view.classList.add("scrolled");
    } else {
      this.view.classList.remove("scrolled");
    }
  }

  /**
   * ナビ情報更新
   */
  updateInfomation(_section, count, total) {
    let section = _section || store.state.app.pinSection.nextSection;
    if (!section) {
      return;
    }
    const controlArea = this.view.querySelector(".js-infocontrol");
    let _id = section.id;

    let notitle = section.getAttribute("data-notitle");
    let title = section.getAttribute("data-category");
    if (notitle) {
      title = null;
    }
    const pause = this.view.querySelector(".js-pause");
    if (pause) {
      pause.style.display = "none"

     if (total > 1 && document.body.classList.contains('user-is-tabbing')) {
      pause.style.display = "block"
     }
    }

    if (total === 1) {
      const wrap = this.view.querySelector(".l-sidenavi__controlwrap");
      if (wrap) {
        wrap.classList.add("hide");
      } else {
        wrap.classList.remove("hide");
      }
    }

    let _subttl = section.getAttribute("data-title");
    if (_subttl) {
      _subttl = "<p class='js-noscroll'>" + _subttl + "</p>";
    }
    const titleArea = this.view.querySelector(".js-infotitle");
    const subtitle = this.view.querySelectorAll(".js-infocsubtitle");

    const textArea = this.view.querySelector(".js-infotext");
    const text = section.getAttribute("data-text");

    const linkArea = this.view.querySelector(".js-contentsinfo-link");
    const link = section.getAttribute("data-link");

    //const extralinkArea = this.view.querySelector(".js-contentsinfo-extralink");
    const extralink = section.getAttribute("data-extralink");

    const linkTextArea = this.view.querySelector(".js-contentsinfo-text");
    const linkText = section.getAttribute("data-link-text") || "";

    let result = false;
    //controlArea
    this.inputCtrl(controlArea, count, total);
    ///// TODO ここで情報エリア非表示
    this.updateInfoArea();

    let fadeTargets;
    if (total) {
      // MultiImage切替時
      fadeTargets = [subtitle];
    } else {
      fadeTargets = [subtitle, titleArea, textArea, linkArea /*, extralinkArea, extralinkTextArea*/];
    }

    gsap.to(fadeTargets, {
      opacity: 0,
      duration: 0.2,
      ease: Quint.easeOut,
      onComplete: () => {
        gsap.to([controlArea, titleArea, subtitle, textArea, linkArea], {
          opacity: 1,
          delay: 0.6,
          duration: 0.24,
          ease: Quint.easeIn,
          onStart: () => {
            //title
            result = this.inputDOM(titleArea, title) || result;
            //subtitle
            _each(subtitle, (elm) => {
              result = this.inputDOM(elm, _subttl) || result;
              if (extralink) {
                elm.setAttribute("href", extralink);
                elm.setAttribute("aria-label", `Go to ${section.dataset.title} video`);
              }
            });
            //text
            result = this.inputDOM(textArea, text) || result;
            //link
            result = this.inputLink(linkArea, link, title) || result;
            result = this.inputDOM(linkTextArea, linkText) || result;
            //extralink
            /// result = this.inputLink(extralinkArea, extralink) || result;
            //extralink
            // result = this.inputDOM(extralinkTextArea, extralinkText) || result;

            this.updateInfoArea(text);
          }
        });
        this.changeBackground(result);
        this.updateBackgroundVisible();
      }
    });
  }

  /**
   * マルチイメージのインジケーター更新
   */
  updateMultiImageIndicator() {
    if (this.activeIndicator) {
      const target = this.activeIndicator.querySelector("span");
      if (!target) {
        return;
      }
      gsap.set(target, {
        scaleX: store.state.app.pinSection.multiImageTime
      });
    }
  }

  /**
   * ナビ、アイコン（これはheader.js）、インジケーターの色を更新
   * beforeScroll もしくは multiImage
   */
  updateColor(isMulti = false) {
    let color;

    if (isMulti) {
      color = store.state.pin.multiImageColor;
      if (color === "white") {
        if (window.innerWidth <= 1024) {
          this.view.classList.add(color);
        }
      } else {
        this.view.classList.remove("white");
      }
    } else {
      let section = store.state.app.pinSection.nextSection;
      if (!section) {
        return;
      }
      color = section.classList.contains("white") ? "white" : "";
      if (color === "white") {
        if(section.classList.contains("sp_black")){
          if (window.innerWidth <= 1024) {
            this.view.classList.remove("white");
          }
        } else {
          // ブランドページのものづくりセクションなどはタブレットサイズでも黒表示の必要があるため
          if (window.innerWidth >= 769) {
            this.view.classList.remove("white");
          } else {
            this.view.classList.add(color);
          }
        }
      } else {
        if(section.classList.contains("brand_top")){
          this.view.classList.add("white");
        } else if(section.classList.contains("sp_white")){
          if (window.innerWidth <= 1024) {
            this.view.classList.add("white");
          }
        } else if(section.classList.contains("sp_white_top")){
          if (window.innerWidth <= 1024) {
            this.view.classList.add("white");
          } else {
            this.view.classList.remove("white");
          }
        } else if(section.classList.contains("sp_black_top")){
          if (window.innerWidth >= 1025) {
            this.view.classList.add("white");
          } else {
            this.view.classList.remove("white");
          }
        }else{
          this.view.classList.remove("white");
        }
      }
    }
  }

  /**
   * 情報エリアの表示切り替え（スマホ用）
   * @param text
   */
  updateInfoArea(text) {
    const infoArea = this.view.querySelector(".js-info");
    if (text) {
      infoArea.classList.add("appear");
    } else {
      infoArea.classList.remove("appear");
    }
  }

  inputDOM(target, text) {
    if (text) {
      target.classList.remove("disabled");
      target.innerHTML = text;
      return true;
    } else {
      target.classList.add("disabled");
      target.innerHTML = "";
      return false;
    }
  }

  inputLink(target, text, title) {
    if (text) {
      target.classList.remove("disabled");
      target.href = text;
      target.setAttribute('aria-label', `View all ${title}`)
      return true;
    } else {
      target.classList.add("disabled");
      target.href = "";
      return false;
    }
  }

  inputCtrl(target, count, total) {
    //const _count = this.view.querySelector('.js-infocontrol__count')
    //const _total = this.view.querySelector('.js-infocontrol__total')
    const _prev = this.view.querySelector(".js-infocontrol__prev");
    const _next = this.view.querySelector(".js-infocontrol__next");
    if (total) {
      const _prevInd = _prev.querySelector("span");
      const _nextInd = _next.querySelector("span");
      gsap.to([_prevInd, _nextInd], {
        scaleX: 0,
        duration: 0.2,
        ease: Cubic.easeOut
      });
      gsap.delayedCall(0.92, () => {
        target.classList.remove("disabled");
      });

      if (count === 0) {
        this.activeIndicator = _prev;
      }
      if (count + 1 === total) {
        this.activeIndicator = _next;
      }
      _prev.setAttribute('aria-current', count === 0)
      _next.setAttribute('aria-current', count + 1 === total)

    } else {
      gsap.delayedCall(0.1, () => {
        target.classList.add("disabled");
      });
    }
  }

  updateInfoControl(sections) {
    const controlArea = this.view.querySelector(".js-infocontrol");

    if (!controlArea) {
      return;
    }

    const buttonControls = controlArea.querySelectorAll("button");

    _each(buttonControls, (button, index) => {
      button.setAttribute("aria-label", `Go to ${sections[index].dataset.title} video`);
    });
  }
}
